import script from "./OrderHistoryCrowdfundingDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistoryCrowdfundingDetail.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistoryCrowdfundingDetail.vue?vue&type=style&index=0&id=09807880&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09807880"]])

export default __exports__